
const state = {
    products: [],
    popover: false,
    timeout: false,
    voucher: null
};

const actions = {
    add({ commit }, product) {
        commit('add', product);
    },
    addSilent({ commit }, product) {
        commit('addSilent', product);
    },
    remove({ dispatch, commit }, index) {

        return dispatch('removeA', index).then(() => {
            if (!getters.voucherAllowed) {
                commit('clearVoucher');
            }
        })
    },
    removeA({ commit }, index) {
        commit('remove', index);
    },
    clear({ commit }) {
        commit('clear')
    },
    clearA({ commit }) {
        commit('clear')
    },
    assignDependant({ commit }, {dependant, index}) {
        commit('assignDependant', {dependant, index});
    },
    addCashback({ commit }, {code, organisation, dependant, index}) {

        commit('addCashback', {code, organisation, dependant, index});

        // for (let i in state.products) {
        //     if (state.products[i].dependant && state.products[i].dependant.id === dependant.id) {
        //         commit('addCashback', {code, organisation, dependant, index});
        //     }
        // }

    },
    removeCashback({ commit }, {index}) {
        console.log("remove:" + index)
        commit('removeCashback', {index})
    },
    applyVoucher({ commit }, {voucher}) {
        console.log(voucher)
        commit('applyVoucher', {voucher});
    },
    clearVoucher({ commit }) {
        commit('clearVoucher');
    },
    closeBasket({ commit }) {
        commit('closeBasket');
    },
};

const mutations = {
    add(state, data) {
        if (state.timeout) {
            clearTimeout(state.timeout);
        }

        state.products.push({
            id: data.product.id,
            name: data.product.name,
            slug: data.product.slug,
            price: data.product.price,
            image: data.product.image,
            post_free: data.product.post_free,
            quantity: 1,
            dependant: null,
            cashback: null,
            activate: data.product.activate,
            personalisable: data.product.personalisable,
            claimable: data.product.claimable
        })
        state.popover = true
        state.timeout = setTimeout(function(){ state.popover = false }, 5000)
    },
    addSilent(state, data) {

        let products = state.products

        for (let x in products) {
            if (products[x].claimable) {
                state.products.splice(x,1);
            }
        }

        state.products.unshift({
            id: data.product.id,
            name: data.product.name,
            slug: data.product.slug,
            price: data.product.price,
            image: data.product.image,
            post_free: data.product.post_free,
            quantity: 1,
            dependant: null,
            cashback: null,
            activate: data.product.activate,
            personalisable: data.product.personalisable,
            claimable: data.product.claimable
        })
    },
    remove(state, index) {

        clearTimeout(state.timeout);

        state.products.splice(index.index,1);
        //setTimeout(closeBasket, 5000)
    },
    clear(state) {
        state.products = []
        state.voucher = null
    },
    assignDependant(state, {dependant, index}) {
        state.products[index] = {...state.products[index], dependant: dependant};
    },
    addCashback(state, {code, organisation, dependant, index}) {
        console.log("cashback added")
        state.products[index].cashback = {
            code: code,
            organisation: organisation,
            dependant: dependant
        }

    },
    removeCashback(state, {index}) {
        if (state.products[index]) {
            state.products[index].cashback = null;
        }
    },
    removeCashbacks(state) {
        let products = state.products

        for (let x in products) {
            if (products[x].cashback) {
                state.products[x].cashback = null;
            }
        }
    },
    applyVoucher(state, {voucher}) {
        state.voucher = voucher;

        // remove cashbacks if voucher applied
        let products = state.products

        for (let x in products) {
            if (products[x].cashback) {
                state.products[x].cashback = null;
            }
        }
    },
    clearVoucher(state) {
        state.voucher = null;
    },
    closeBasket(state) {
        state.popover = false;
    }
};

const getters = {
    products: state => {
        return state.products
    },
    productsCount: (state, getters) => {
        return getters.products.length.toString()
    },
    productsTotal: (state, getters) => {
        let products = getters.products;
        let total = 0;
        for (let i in products) {
            let quantity = products[i].quantity ? products[i].quantity : 1
            total += parseFloat(products[i].price) * quantity
        }

        return total.toFixed(2);
    },
    basketTotal: (state, getters) => {
        let products = getters.products;
        let total = 0;
        for (let i in products) {
            let quantity = products[i].quantity ? products[i].quantity : 1
            total += parseFloat(products[i].price) * quantity
        }

        if (total === 0) {
            return 0
        }
        //let postage = getters.postage

        return total.toFixed(2);
    },
    productById: (state, id) => {
        let products = state.products;

        if (products) {
            let product = products.find(el => el.id === id);

            if (product) {
                return product;
            }
        }
        return false;
    },
    productForCreateMany: state => {
        let products = [];
        for (let i in state.products) {
            console.log(state.products[i])
            let dependantId = state.products[i].dependant && state.products[i].dependant.id !== 0 ? state.products[i].dependant.id : null
            console.log(dependantId)
            let cashbackCode = state.products[i].cashback ? state.products[i].cashback.code : null
            products.push({'product_id': state.products[i].id, quantity: state.products[i].quantity, activate: state.products[i].activate, 'dependant_id': dependantId, 'cashback': cashbackCode, 'claimable': state.products[i].claimable})
        }
        console.log(products)
        return products
    },
    containsOnlyPostFree: state => {
        let onlyPostFree = true;
        for (let i in state.products) {
            if (state.products[i].post_free === false) {
                onlyPostFree = false
            }
        }
        return onlyPostFree
    },
    cashbacks: (state) => {
        return state.cashbacks;
    },
    hasCashback: (state, getters) => (id) => {
        let products = getters.products

        for (let x in products) {
            if (products[x].cashback && products[x].cashback.dependant && products[x].cashback.dependant.id === id) {
                return products[x].cashback
            }
        }

        return false
    },
    voucherDiscount: (state, getters) => {
        if (state.voucher) {
            let subTotal = getters.productsTotal
            let discount = subTotal * (state.voucher.amount / 100)
            return discount.toFixed(2)
        }
        return 0;
    },
    voucher: (state) => {
        return state.voucher;
    },
    voucherAllowed: (state) => {
        let products = state.products

        for (let x in products) {
            if (products[x].claimable !== true) {
                return true
            }
        }

        return false
    },
    postage: (state) => {
        let products = state.products

        let includePostage = false;

        for (let x in products) {
            if (products[x].post_free !== true) {
                return 1.99
            }
        }

        return 0
    },
    claimedProduct: (state) => {
        let products = state.products


        for (let x in products) {
            if (products[x].claimable) {
                return products[x]
            }
        }

        return null
    },
    claimedProductPersonalised:  (state) => {
        let products = state.products

        for (let x in products) {
            if (products[x].claimable) {
                return products[x].name
            }
        }

        return null
    },
    onlyClaimable: (state) => {
        let products = state.products

        for (let x in products) {
            if (products[x].claimable !== true) {
                return false
            }
        }

        return true
    },
}

export const basket = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
